new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);
    $('.product-ratings-list').slick({
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    });
    waitForElementToExist('.product_list').then(element => {
        $('.product_list').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 100,
        responsive: [{
            breakpoint: 577,
            settings: {
            slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
            slidesToShow: 3
            }
        }, {
            breakpoint: 991,
            settings: {
            slidesToShow: 4
            }
        }]
        });
    });
    waitForElementToExist('.product_list3').then(element => {
        $('.product_list3').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 100,
        responsive: [{
            breakpoint: 577,
            settings: {
            slidesToShow: 2
            }
        }, {
            breakpoint: 767,
            settings: {
            slidesToShow: 3
            }
        }, {
            breakpoint: 991,
            settings: {
            slidesToShow: 4
            }
        }]
        });
    });
    waitForElementToExist('.banner-blog').then(element => {
        $('.banner-blog').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 100,
        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
        });
    });
})